var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPoudre(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 65.65,
    height: 50.597,
    viewBox: "0 0 65.65 50.597",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_219",
    "data-name": "Rectangle 219",
    width: 65.65,
    height: 50.597,
    fill: "#fff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_201",
    "data-name": "Groupe 201",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_200",
    "data-name": "Groupe 200",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_251",
    "data-name": "Trac\\xE9 251",
    d: "M35.3,23.36a.869.869,0,0,1-.523-1.565l2.971-2.228a.869.869,0,1,1,1.043,1.39l-2.971,2.228a.866.866,0,0,1-.521.174",
    transform: "translate(-4.495 -2.532)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_253",
    "data-name": "Trac\\xE9 253",
    d: "M36.055,26.935a.87.87,0,0,1-.521-1.567l4.107-3.06A.869.869,0,0,1,40.681,23.7l-4.106,3.061a.865.865,0,0,1-.519.172",
    transform: "translate(-3.593 -3.89)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_255",
    "data-name": "Trac\\xE9 255",
    d: "M39.468,28.792a.87.87,0,0,1-.551-1.542l3.5-2.865a.87.87,0,0,1,1.1,1.346l-3.5,2.865a.867.867,0,0,1-.55.2",
    transform: "translate(-5.039 -3.158)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_257",
    "data-name": "Trac\\xE9 257",
    d: "M39.569,32.651A.869.869,0,0,1,39.03,31.1l5.518-4.351a.869.869,0,1,1,1.076,1.365l-5.517,4.351a.864.864,0,0,1-.538.187",
    transform: "translate(-5.052 -3.468)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_259",
    "data-name": "Trac\\xE9 259",
    d: "M40.924,36.183a.869.869,0,0,1-.539-1.552L45.9,30.28a.869.869,0,1,1,1.076,1.365L41.463,36a.864.864,0,0,1-.538.187",
    transform: "translate(-4.582 -4.46)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_261",
    "data-name": "Trac\\xE9 261",
    d: "M44.65,38.506a.869.869,0,0,1-.539-1.552l5.518-4.35a.869.869,0,1,1,1.076,1.365l-5.517,4.35a.866.866,0,0,1-.538.187",
    transform: "translate(-5.716 -4.232)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_264",
    "data-name": "Trac\\xE9 264",
    d: "M50.554,41.714a.869.869,0,0,1-.543-1.548l3.759-3a.869.869,0,0,1,1.085,1.358l-3.758,3a.864.864,0,0,1-.543.19",
    transform: "translate(-7.487 -5.827)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_265",
    "data-name": "Trac\\xE9 265",
    d: "M54.425,42.165a.869.869,0,0,1-.562-1.534L55.6,39.163a.869.869,0,1,1,1.122,1.328L54.986,41.96a.865.865,0,0,1-.561.205",
    transform: "translate(-6.992 -5.086)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_266",
    "data-name": "Trac\\xE9 266",
    d: "M46.51,14.189a.868.868,0,0,1-.868-.822L44.973.916A.87.87,0,0,1,46.71.823l.669,12.45a.871.871,0,0,1-.823.916H46.51",
    transform: "translate(-5.871 0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_267",
    "data-name": "Trac\\xE9 267",
    d: "M55.476,19.29a.869.869,0,0,1-.675-1.417l6.523-8.049a.869.869,0,1,1,1.35,1.1l-6.523,8.049a.868.868,0,0,1-.676.322",
    transform: "translate(-7.129 -1.241)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_268",
    "data-name": "Trac\\xE9 268",
    d: "M60.76,27.7a.869.869,0,0,1-.173-1.721l11.839-2.415a.869.869,0,1,1,.347,1.7L60.934,27.684a.865.865,0,0,1-.175.018",
    transform: "translate(-7.819 -3.074)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_269",
    "data-name": "Trac\\xE9 269",
    d: "M54.16,52.608a3.129,3.129,0,0,1-.493-.038H3.868a3.9,3.9,0,0,1-2.93-1.327A3.722,3.722,0,0,1,.03,48.309c1.007-7.818,17.258-23.1,26.855-31.508a5.667,5.667,0,0,1,8,.541C59.734,45.786,57.3,49.987,56.5,51.367a2.611,2.611,0,0,1-2.341,1.241M30.608,17.139a3.885,3.885,0,0,0-2.576.97C12.251,31.94,2.428,43.314,1.755,48.532A1.961,1.961,0,0,0,2.244,50.1a2.164,2.164,0,0,0,1.624.736H53.83l.084.017s.8.137,1.085-.359c.6-1.063.84-6.517-21.42-32a3.914,3.914,0,0,0-2.706-1.34c-.089-.006-.178-.009-.266-.009m-3.149.316h0Z",
    transform: "translate(0 -2.011)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPoudre);
export default __webpack_public_path__ + "static/media/POUDRE.4b791c752afbb3fd55cb3fa226f7b7fc.svg";
export { ForwardRef as ReactComponent };